import { useQueryClient as c, useMutation as u } from "react-query";
import { useEnvironment as a } from "../../../common/hooks/environment/useEnvironment.js";
import { useAuth as m } from "../../../auth/hooks/useAuth.js";
const d = 2;
function l() {
  const e = a(), {
    token: o
  } = m(), n = c();
  return u(async (t) => {
    const {
      backendBaseUrl: s
    } = e, {
      code: r,
      accessPointId: i
    } = t;
    return (await fetch(`${s}/gift-promotion/${r}/`, {
      method: "PUT",
      body: JSON.stringify({
        access_point_id: i,
        action: d
      }),
      headers: {
        authorization: `Token ${o}`
      }
    })).json();
  }, {
    onSuccess: () => {
      n.invalidateQueries({
        queryKey: ["customer-vouchers"]
      });
    }
  });
}
export {
  l as useBurnVoucher
};
//# sourceMappingURL=useBurnVoucher.js.map
